let ideas;
let itemList;
let items;
let itemCount;
let counterItems;

const createCounter = () => {
	const counter = document.createElement("div");
	counter.classList.add("counter");
	const counterWrapper = document.createElement("div");
	counterWrapper.classList.add("counter-wrapper");
	for (let x = 0; x <= itemCount; x++) {
		let item = document.createElement("div");
		item.classList.add("counter-item");
		item.innerHTML = x + 1;
		counterWrapper.append(item);
	}
	counter.append(counterWrapper);
	itemList.append(counter);
};

const itemCounter = () => {
	items[itemCount].classList.remove("active");
	counterItems[itemCount].classList.remove("active");
	itemCount++;
	itemCount = itemCount % items.length;
	items[itemCount].classList.add("active");
	counterItems[itemCount].classList.add("active");
};

const ideaSlide = () => {
	ideas = document.querySelector("#ideas");
	itemList = ideas.querySelector(".tag-items");
	itemList.classList.add("init");
	items = itemList.querySelectorAll(".tag-item");
	itemCount = items.length - 1;
	createCounter();
	counterItems = ideas.querySelectorAll(".counter-item");
	itemCounter();
	setInterval(itemCounter, 5000);
};

export { ideaSlide };
